'use client';

import { ReactNode, useCallback, useEffect, useState } from 'react';

import { NavigationStateContext } from '../context/navigation-state-context';

interface NavigationStateProviderProps {
  children: ReactNode;
}

export function NavigationStateProvider(props: NavigationStateProviderProps) {
  const [isBackOrForward, setIsBackOrForward] = useState<boolean>(false);

  const handleWindowPopstate = useCallback(
    (event: PopStateEvent) => {
      setIsBackOrForward(true);
    },
    [setIsBackOrForward]
  );

  useEffect(() => {
    window.addEventListener('popstate', handleWindowPopstate);

    return () => {
      window.removeEventListener('popstate', handleWindowPopstate);
    };
  }, []);

  useEffect(() => {
    if (!isBackOrForward) {
      return;
    }

    const timeout = setTimeout(() => {
      setIsBackOrForward(false);
    }, 0);

    return () => clearTimeout(timeout);
  }, [isBackOrForward]);

  return (
    <NavigationStateContext.Provider
      value={{
        isBackOrForward: isBackOrForward,
      }}
    >
      {props.children}
    </NavigationStateContext.Provider>
  );
}
